const getStylesByPrefix = (prefix, styles) =>
  Object.fromEntries(
    Object.entries(styles)
      .filter(([key]) => key.startsWith(prefix))
      .map(([key, value]) => [key.replace(prefix, ''), value])
  );

const toStyleKey = (key) =>
  key.startsWith('--')
    ? key
    : key.replace(/-([a-z])/g, (match, char) => char.toUpperCase());

const toStyleObject = (styles = {}) =>
  Object.fromEntries(
    Object.entries(styles)
      .filter(([, value]) => ['string', 'number'].includes(typeof value))
      .map(([key, value]) => [toStyleKey(key), value])
  );

const appendStylesByPrefix = (parent, child, prefix, filteredOnly) => {
  return {
    ...child,
    fields: {
      ...child.fields,
      settings: [
        ...(filteredOnly ? [] : child.fields?.settings || []),
        ...(parent.fields?.settings
          ?.filter(({ fields }) => fields.key.startsWith(prefix))
          .map((setting) => {
            return {
              ...setting,
              fields: {
                ...setting.fields,
                key: setting.fields.key.replace(prefix, ''),
              },
            };
          }) || []),
      ],
    },
  };
};
const parseBool = (value) => {
  if (value === 'true' || value === true) return true;
  if (value === 'false' || value === false) return false;
  return undefined;
};

const parseVideoSettings = (styles = {}) => {
  const raw = getStylesByPrefix('--video-', styles);
  const out = {};
  if ('autoplay' in raw) out.autoplay = parseBool(raw.autoplay);
  if ('loop' in raw) out.loop = parseBool(raw.loop);
  if ('muted' in raw) out.muted = parseBool(raw.muted);
  if ('controls' in raw) out.controls = parseBool(raw.controls);
  if ('playsinline' in raw) out.playsInline = parseBool(raw.playsinline);
  if ('preload' in raw) out.preload = raw.preload;
  return out;
};

module.exports = {
  getStylesByPrefix,
  appendStylesByPrefix,
  parseVideoSettings,
  toStyleObject,
};
